import { Pagination } from '../..';

export const DEFAULT_PAGINATION_STATE: Pagination = {
  pageSize: Infinity,
  firstPage: true,
};
